import { Component } from "@angular/core";
import { NavParams } from "ionic-angular";
import { PointStatListItem } from "lib/types/PointStatListItem";

@Component({
    selector: 'staff-point-stats-logs',
    templateUrl: './point-stats-logs.component.html',
})
export class PointStatsLogsComponent {
    pointStat: PointStatListItem;

    constructor(params: NavParams) {
        this.pointStat = params.get('pointStat');
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/rodeo/results/point-stats-logs/point-stats-logs.component.ts